import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashcan = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M192.004 917.334c0 58.666 48 106.666 106.666 106.666h426.667c58.666 0 106.666-48 106.666-106.666v-533.333c0-58.666-48-106.666-106.666-106.666h-426.667c-58.666 0-106.666 48-106.666 106.666v533.333zM832.003 117.333h-133.334l-37.867-37.867c-9.6-9.6-23.467-15.466-37.334-15.466h-222.934c-13.867 0-27.734 5.866-37.334 15.466l-37.867 37.867h-133.334c-29.333 0-53.333 24-53.333 53.333s24 53.333 53.333 53.333h640.001c29.333 0 53.333-24 53.333-53.333s-24-53.333-53.333-53.333z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTrashcan);
export default ForwardRef;
